(() => {
  if (customElements.get('bw-mobile-description')) return;
  customElements.define('bw-mobile-description', class extends HTMLElement {
    connectedCallback() {
      const full = this.querySelector('.bw-description-full');
      const preview = this.querySelector('.bw-description-preview');
      const button = this.querySelector('.bw-description-toggle');
      if (!full || !preview || !button) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const copy = full.cloneNode(true);
      copy.querySelectorAll('script,style,noscript').forEach(el => el.remove());
      copy.querySelectorAll('p,li,h1,h2,h3,h4,div,br,tr').forEach(el => el.append(' '));
      const text = copy.textContent.replace(/\s+/g, ' ').trim();
      const long = text.length > 340;
      const paragraphs = Array.from(copy.querySelectorAll('p')).map(el => el.textContent.trim()).filter(Boolean).join(' ').replace(/\s+/g, ' ');
      const previewText = paragraphs.length >= 140 ? paragraphs : text;
      const excerpt = previewText.slice(0, 280).replace(/\s+\S*$/, '').replace(/[\s,;:.-]+$/, '');
      preview.textContent = excerpt + '…';
      let expanded = false;
      const update = () => {
        preview.hidden = !long || expanded;
        full.hidden = long && !expanded;
        button.hidden = !long;
        button.setAttribute('aria-expanded', String(long && expanded));
        button.querySelector('[data-label]').textContent = expanded ? this.dataset.less : this.dataset.more;
        this.setAttribute('data-ready', '');
      };
      button.addEventListener('click', () => { expanded = !expanded; update(); }, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();
